import { render, staticRenderFns } from "./BusquedaColegiado.vue?vue&type=template&id=6bd91a0a"
import script from "./BusquedaColegiado.vue?vue&type=script&lang=js"
export * from "./BusquedaColegiado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports